import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ErrorPageComponent } from '@reg/error-page/error-page.component';

/**
 * Application wide routes. Lazy loaded modules are specified via
 * loadChildren with a path to the module and class name.
 */
const appRoutes: Routes = [
    {
        path: 'login',
        loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
    },
    // Event Setup Routes
    {
        path: 'event/:event-id/setup',
        loadChildren: () => import('./event/setup/event-setup.module').then(m => m.EventSetupModule),
    },
    // Event Summary Routes
    {
        path: 'event/:event-id',
        redirectTo: '/event/:event-id/summary',
        pathMatch: 'full',
    },
    {
        path: 'event/:event-id/summary',
        loadChildren: () => import('./event/summary/event-summary.module').then(m => m.EventSummaryModule),
    },
    // Event Admin (dashboard and data-management) Routes
    {
        path: 'event/:event-id/admin',
        loadChildren: () => import('./event/admin/event-admin.module').then(m => m.EventAdminModule),
    },
    // Registration Routes
    {
        path: 'event/:event-id/registration',
        loadChildren: () => import('./event/registration/event-registration.module')
            .then(m => m.EventRegistrationModule),
    },
    // Event Roster Routes
    {
        path: 'event/:event-id/roster',
        loadChildren: () => import('./event/roster/event-roster.module').then(m => m.EventRosterModule),
    },
    // Print Routes
    {
        path: 'print',
        loadChildren: () => import('./print/print.module').then(m => m.PrintModule),
    },
    // User Routes
    {
        path: '',
        redirectTo: '/user',
        pathMatch: 'full',
    },
    {
        path: 'user',
        loadChildren: () => import('./user/user.module').then(m => m.UserModule),
    },
    // Identity and Claim Routes
    {
        path: 'identity/claim',
        loadChildren: () => import('./identity/claim/identity-claim.module').then(m => m.IdentityClaimModule),
    },
    // Admin Routes
    {
        path: 'admin',
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
    },
    // Error Routes
    {
        path: 'error',
        loadChildren: () => import('./error-page/error-page.module').then(m => m.ErrorPageModule),
    },
    // Unsubscribe Routes
    {
        path: 'unsubscribe',
        loadChildren: () => import('./unsubscribe/unsubscribe.module').then(m => m.UnsubscribeModule),
    },
    // 404 Page not found route
    {
        path: '**',
        component: ErrorPageComponent,
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, { enableTracing: false }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {
}
